import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const TataTeleModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apikey, setApikey] = useState("");
    const [errorApikey, setErrorApikey] = useState(false);
    const [orgurl, setOrgUrl] = useState("");
    const [errorOrgUrl, setErrorOrgUrl] = useState(false);

    const handleSubmit = async (values) => {
        if (!apikey) {
            setErrorApikey(true);
        }
        let provider = {
            accessToken: apikey,
            provider: "tataTele",
            service: "Dialer",
        }
        try {
            let response = await postJsonAxiosService("tataTele/webhook/validate", {provider: provider});
            if (response) {

                if (response?.data === "Incorrect API key") {
                    toastService.error("Invalid Api Key");
                } else {
                    if (!user.providers || user.providers.length == 0) {
                        user.providers = [];
                    }
                    user.providers?.push(provider);
                    toastService.info("Tata Tele Integrated");
                    window.location.reload();
                }
            }
        } catch (e) {
            toastService.error("Error while updating integration");
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Tata Tele Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>Permanent Account Token </label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter permanent account token"
                               value={apikey}
                               onChange={(e) => {
                                   setApikey(e.target.value);
                                   setErrorApikey(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter permanent account token
                            </div>
                        ) : null}
                    </div>
                    <div>
                    </div>
                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit}>
                    Authorize
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default TataTeleModal;
